export const STOCK_FILTER_VALUES = {
  ALL: 'all',
  UNDER_THRESHOLD: 'under_threshold',
  EFFECTIVE_LE_ZERO: 'effective_le_zero',
  RESERVED_GT_ZERO: 'reserved_gt_zero',
}

export const STOCK_FILTER_OPTIONS = [
  { value: STOCK_FILTER_VALUES.ALL, label: 'Tutto stock' },
  { value: STOCK_FILTER_VALUES.UNDER_THRESHOLD, label: 'Sottoscorta' },
  { value: STOCK_FILTER_VALUES.EFFECTIVE_LE_ZERO, label: 'Effettiva <= 0' },
  { value: STOCK_FILTER_VALUES.RESERVED_GT_ZERO, label: 'Riservata > 0' },
]

function toNumberOrZero(value) {
  const parsed = Number(value)
  return Number.isFinite(parsed) ? parsed : 0
}

export function getStockSnapshot(giacenza, lowFallback = 5) {
  const disponibile = toNumberOrZero(giacenza?.quantita_disponibile)
  const riservata = toNumberOrZero(giacenza?.quantita_riservata)
  const effettiva = giacenza?.quantita_effettiva != null
    ? toNumberOrZero(giacenza.quantita_effettiva)
    : (disponibile - riservata)
  const sogliaMinima = giacenza?.soglia_minima != null
    ? toNumberOrZero(giacenza.soglia_minima)
    : null

  const isUnderThreshold = sogliaMinima != null
    ? effettiva < sogliaMinima
    : effettiva <= lowFallback

  return {
    disponibile,
    riservata,
    effettiva,
    sogliaMinima,
    isUnderThreshold,
  }
}

export function matchesStockFilter(giacenza, stockFilterValue, options = {}) {
  if (stockFilterValue === STOCK_FILTER_VALUES.ALL) {
    return true
  }

  if (!giacenza) {
    return false
  }

  const { lowFallback = 5 } = options
  const snapshot = getStockSnapshot(giacenza, lowFallback)

  switch (stockFilterValue) {
    case STOCK_FILTER_VALUES.UNDER_THRESHOLD:
      return snapshot.isUnderThreshold
    case STOCK_FILTER_VALUES.EFFECTIVE_LE_ZERO:
      return snapshot.effettiva <= 0
    case STOCK_FILTER_VALUES.RESERVED_GT_ZERO:
      return snapshot.riservata > 0
    default:
      return true
  }
}
